export default {
  profileSettings: {
    // accentColor: null,
    isPorta: false,
    authorityUrl: null,
    returnUrl: null,
    aId: null,
    navigationMenu: {
      isOpened: false,
      hasNavigationMenu: true,
      currentPage: 0,
    },
    languagesDropdown: [],
    language: {
      client_account_site_license_users_add_user_email_address: 'Email Address',
      client_account_subscriptions_redeem_invitation: 'Redeem',
      client_account_subscriptions_item_cancel_subscription: 'Cancel Subscription',
      client_account_site_license_no_licenses: 'You have no site licenses at this time.',
      client_account_notification_payment_receipt_download_failed: 'Payment receipt download failed!',
      client_account_notification_getting_ready_to_download_payment_receipt: 'Getting ready to download the payment receipt!',
      client_account_notification_resend_gift_email_successfully: 'Resent gift email successfully!',
      client_account_subscriptions: 'Subscriptions',
      client_account_gifts_description: 'Manage subscriptions that you have gifted or received from others.m',
      client_account_gifts_item_to: 'To',
      client_account_gifts: 'Gifts',
      client_account_payments_tab_info: 'Manage Payment Info',
      client_account_subscription_item_renewing_on: 'Renewing on:',
      client_account_gifts_status_redeemed: 'Redeemed',
      client_account_site_license_users_table_manage_resend_invitation: 'Resend invitation',
      client_account_gifts_item_voucher_name: 'Name',
      client_account_notification_failed_to_add_user: 'Failed to add user!',
      client_account_site_license_users_table_manage_send_new_invitation: 'Send new invitaiton',
      client_account_payments_info_prefered: 'Prefered ',
      client_account_notification_failed_to_revoke_user_access: 'Failed to revoke user access!',
      client_account_notification_resend_invitation_successfully: 'Resent invitation successfully!',
      client_account_payments_history_options: 'Options',
      client_account_subscription_item_expired_on: 'Expired on:',
      client_account_site_license_users_add_user_first_name: 'First Name',
      client_account_my_account_edit_info: 'To Edit profile information, we will redirect you to PORTA.',
      client_account_notification_payment_retry_failed: 'Payment retry failed!',
      client_account_payments_history_download_receipt: 'Download receipt',
      client_account_site_license_users_add_user_add: 'Add',
      client_account_site_license_back: 'Go back',
      client_account_gifts_item_message: 'Message',
      client_account_notification_failed_to_redeem_access: 'Failed to redeem access!',
      client_account_site_license_users_modal_remove_invitation_body: 'Are you sure you want to remove invitation from this user ?',
      client_account_payments_history: 'Payments & History',
      client_account_subscription_item_ending_on: 'Ending on:',
      client_account_payments_history_subscription_plan: 'Subscription Plan',
      client_account_gifts_vouchers_dropdown_third_party_vouchers: 'Third-party Vouchers',
      client_account_payment_status_waiting: 'Waiting',
      client_account_gifts_vouchers_dropdown_vouchers: 'Vouchers',
      client_account_notification_failed_to_resend_invitation: 'Failed to resend invitation!',
      client_account_gifts_item_access_to: 'Access to',
      client_account_site_license_users_table_name: 'Name',
      client_account_subscriptions_table_subscription_plan: 'Subscription Plan',
      client_account_site_license_users_table_manage: 'Manage',
      client_account_subscriptions_table_product_name: 'Product Name',
      client_account_site_license_users_add_user_cancel: 'Cancel',
      client_account_site_license_users_table_manage_remove_invitation: 'Remove invitation',
      client_account_subscription_item_expires_on: 'Expires on: ',
      client_account_site_license_users_table_status: 'Status',
      client_account_site_license_users_add_user_header: 'Add User',
      client_account_payments_history_no_payments: 'You have no payments at this time.',
      client_account_notification_added_user_successfully: 'Added user successfully!',
      client_account_notification_subscription_canceled_successfully: 'Subscription canceled successfully!',
      client_account_my_account_email: 'Email Address',
      client_account_notification_failed_to_remove_invitation: 'Failed to remove invitation!',
      client_account_notification_removed_invitation_successfully: 'Removed invitation successfully!',
      client_account_subscriptions_status_organization: 'Organization',
      client_account_subscriptions_activity_canceled: 'Canceled',
      client_account_gifts_modal_resend_gift_email_body: 'Are you sure you want to resend email?',
      client_account_subscriptions_activity_on_trial: 'On trial',
      client_account_payments_info_edit_text: 'Edit your payment details, add a backup, or switch your preferred payment method.',
      client_account_payment_status_paid: 'Paid',
      client_account_subscriptions_status_gift: 'Gift',
      client_account_payments_history_send_to_email: 'Send to email',
      client_account_my_account_edit_info_button: 'Edit My Account',
      client_account_payments_history_amount: 'Amount',
      client_account_payments_history_status: 'Status',
      client_account_gifts_tab_gifts: 'Gifts',
      client_account_notification_payment_receipt_downloaded_successfully: 'Payment receipt downloaded successfully!',
      client_account_notification_sent_new_invitation_successfully: 'Sent new invitation successfully!',
      client_account_subscriptions_table_date: 'Date',
      client_account_notification_failed_to_remove_user: 'Failed to remove user!',
      client_account_payments_info_make_prefered: 'Make prefered',
      client_account_log_out: 'Log out',
      client_account_gifts_status_expired: 'Expired',
      client_account_gifts_item_voucher_benefit: 'Benefit',
      client_account_site_license_users_add_user_last_name: 'Last Name',
      client_account_payments_info_add_payment_method: 'Add payment method',
      client_account_site_license: 'Site Licence',
      client_account_site_license_users_add_user: 'Add User',
      client_account_notification_failed_to_resend_gift_email: 'Failed to resend gift email!',
      client_account_site_license_users_modal_revoke_access_body: "Are you sure you want to revoke this user's access ?",
      client_account_gifts_item_resend_gift_email: 'Resend gift email',
      client_account_gifts_table_no_gifts: 'You have no gifts at this time.',
      client_account_notification_removed_user_successfully: 'Removed user successfully!',
      client_account_my_account_password: 'Password',
      client_account_subscriptions_tab_active: 'Active',
      client_account_notification_failed_to_send_email: 'Failed to send email!',
      client_account_my_account_description: 'Update details for your account',
      client_account_subscriptions_table_activity: 'Activity',
      client_account_site_license_description: 'Access your site licenses and manage their users',
      client_account_site_license_users_table_manage_revoke: 'Revoke',
      client_account_gifts_status_incomplete: 'Incomplete',
      client_account_gifts_status_unknown: 'Unknown',
      client_account_subscriptions_item_cancel_modal_yes_cancel_button: 'Yes, Cancel',
      client_account_gifts_table_no_vouchers: 'You have no vouchers at this time.',
      client_account_gifts_vouchers_item_redeem_voucher: 'Redeem Voucher',
      client_account_gifts_options: 'Options',
      client_account_subscriptions_tab_expired: 'Expired',
      client_account_site_license_users_modal_remove_user_body: 'Are you sure you want to remove this user ?',
      client_account_site_license_users_modal_send_new_invitation_body: 'Are you sure you want to send a new invitation to this user ?',
      client_account_my_account: 'My Account',
      client_account_site_license_no_license_users: 'No users at this time.',
      client_account_site_license_start_date: 'Starts from',
      client_account_payment_status_refunded: 'Refunded',
      client_account_gifts_item_price: 'Price',
      client_account_notification_an_email_has_been_sent: 'An email has been sent!',
      client_account_subscriptions_table_no_expired_subscriptions: 'You have no expired subscriptions at this time.',
      client_account_gifts_item_subscription: 'Subscription',
      client_account_subscriptions_item_cancel_modal_header: 'Cancel Subscription',
      client_account_notification_user_access_revoked_successfully: 'User access revoked successfully!',
      client_account_subscriptions_item_cancel_modal_body: 'Are you sure you want to cancel your subscription? Cancellation will be effective at the end of your current billing period on',
      client_account_payments_info_no_info: "You don't have any payment information",
      client_account_subscriptions_item_renewing_on: 'Renewing on',
      client_account_subscriptions_item_cancel_modal_go_back_button: 'Go back',
      client_account_payment_status_canceled: 'Canceled',
      client_account_payments_description: 'Manage your Payment Info and access your Payments History.',
      client_account_subscriptions_table_options: 'Options',
      client_account_subscriptions_description: 'Manage your Active and Expired subscriptions.',
      client_account_site_license_users_table_options: 'Options',
      client_account_notification_failed_to_send_new_invitation: 'Failed to send new invitation!',
      client_account_notification_subscription_cancelation_failed: 'Subscription cancelation failed!',
      client_account_gifts_item_voucher_code: 'Voucher Code',
      client_account_subscriptions_item_expires_on: 'Expires on',
      client_account_gifts_vouchers_item_redeem_url: 'Redeem URL',
      client_account_payments_history_date: 'Date',
      client_account_site_license_license_user_not_found: 'User not found.',
      client_account_subscriptions_table_no_active_subscriptions: 'You have no active subscriptions at this time.',
      client_account_payments_tab_history: 'Payments History',
      client_account_site_license_users_modal_resend_invitation_body: 'Are you sure you want to resend invitation to this user ?',
      client_account_gifts_item_status: 'Status',
      client_account_payment_status_failed: 'Failed',
      client_account_notification_redeemed_access_successfully: 'Redeemed access successfully!',
      client_account_gifts_status_unclaimed: 'Unclaimed',
      client_account_site_license_user_search: 'Search...',
      client_account_payments_history_retry_payment: 'Retry Payment',
      client_account_gifts_item_from: 'From',
      client_account_gifts_tab_my_vouchers: 'My Vouchers',
      client_account_gifts_modal_resend_gift_email: 'Resend gift email',
    },

  },
  currentLanguage: { id: 1 },
  paymentMethodId: null,

  clientAccount: {
    token: false,
    email: '',
    autoRenewingEnabled: false,
    isLicenseManager: false,
    expiredSubscriptions: [],
    activeSubscriptions: [],
    siteLicenses: [],
    gifts: [],
    vouchers: [],
    externalVouchers: [],
    siteLicenseUsers: [],
    siteLicenseInvitations: [],
    paymentInfo: {
      braintreeClientToken: null,
      stripeClientToken: null,
      selectedPaymentInfo: {},
      paymentInfos: [],
      paymentsHistory: [],
    },
  },
  clientAccountFetched: false,
  areSubscriptionsValid: true,


  isLoading: true,
  mainIsLoading: true,
  portaMainIsLoading: true,
  addEditPaymentMethodIsLoading: false,

  pageHeight: 400,
  confirmationModal: {
    type: null,
    show: false,
    subscription: null,
  },
  showAddMemberModal: false,
  showContactSupportModal: false,
  contactSupportButtonDisabled: false,

  activeSubscriptionsSettings: {
    filters: {
      params: {
        StatusId: 2,
        Take: 7,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 1,
    },
  },
  expiredSubscriptionsSettings: {
    filters: {
      params: {
        StatusId: 3,
        Take: 7,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 1,
    },
  },
  paymentsSettings: {
    filters: {
      params: {
        Take: 7,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 3,
    },
  },

  paymentInfosSettings: {
    addPaymentMethod: false,
    editPaymentMethod: false,
    filters: {
      params: {
        Take: 7,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 2,
      totalCount: null,
      currentPage: 2,
      pageSize: 3,
    },
  },

  licenseSettings: {
    isLicenseSelected: false,
    selectedLicenseId: null,
    membershipsTotal: 0,
    membershipsUsed: 0,
    selectedLicenseName: null,
    filters: {
      params: {
        Take: 4,
        Page: 1,
        OrderDescending: true,
      },
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 4,
    },
  },
  licenseUsersSettings: {
    selectedLicenseUserId: null,
    selectedLicenseUserEmail: null,
    addMemberInformation: {
      firstName: null,
      lastName: null,
      emailAddress: null,
    },
    filters: {
      params: {
        email: '',
        Take: 7,
        Page: 1,
        OrderDescending: true,
      },
    },
    pagination: {
      totalPages: 1,
      totalCount: 0,
      currentPage: 1,
      pageSize: 6,
    },
  },

  licenseInvitationsSettings: {
    filters: {
      params: {
        Take: 3,
        Page: 1,
        OrderDescending: true,
      },
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 1,
    },
  },
  giftsSettings: {
    selectedGiftId: null,
    filters: {
      params: {
        Take: 5,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 6,
    },
  },
  vouchersSettings: {
    selectedVocuherId: null,
    filters: {
      params: {
        Take: 3,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 6,
    },
  },
  externalVouchersSettings: {
    selectedVocuherId: null,
    filters: {
      params: {
        Take: 3,
        Page: 1,
        OrderDescending: true,
      },
    },
    navigation: {
      currentTab: 0,
    },
    pagination: {
      totalPages: 1,
      totalCount: null,
      currentPage: 1,
      pageSize: 6,
    },
  },
}
